export {}

declare global {
  interface Array<T> {
    groupBy<K>(keySelector: (item: T) => K): Map<K, Array<T>>
    fold<A, T>(initial: Array<A>, operation: (previousValues: Array<A>, currentValue: T) => A): Array<A>
  }
}

Array.prototype.groupBy = function(keySelector: (item: any) => any): Map<any, Array<any>> {
  return (this as Array<any>).reduce((items: Map<any, Array<any>>, item: any) => {
    const key = keySelector(item)
    if (!items.has(key)) {
      items.set(key, [])
    }
    // @ts-ignore because there always is a list in there
    items.get(key).push(item)
    return items
  }, new Map<any, Array<any>>())
}

const sum = (array: Array<number>): number =>
  [...array].reduce((p, i) => p + i, 0)

const median = (array: Array<number>): number => {
  const sortedNumbers = [...array].sort((l, r) => l - r)
  const middle = Math.floor(sortedNumbers.length / 2)
  if (sortedNumbers.length % 2 === 0) {
    return (sortedNumbers[middle - 1] + sortedNumbers[middle]) / 2
  } else {
    return sortedNumbers[middle]
  }
}

Array.prototype.fold = function<A, T>(initial: Array<A>, operation: (previousValues: Array<A>, currentValue: T) => A): Array<A> {
  this.forEach((value) => initial.push(operation(initial, value)))
  return initial
}

export { median, sum }
